import { all } from "redux-saga/effects";
import Signup from "./auth/signupSaga";
import Login from "./auth/loginSaga";
import Logout from "./auth/logoutSaga";
import VerifyEmail from "./auth/verifyEmailSaga";
import AddNewAddress from "./auth/addNewAddressSaga";
import GetAddressCard from "./auth/getAddressCardSaga";
import CompleteKYC from "./kyc/completeKYCSaga";
import KYCAuth from "./kyc/kycAuthSaga";

import GetBalance from "./dashboard/getBalanceSaga";
import GetUserData from "./dashboard/getUserDataSaga";
import DepositMoneyPlant from "./dashboard/depositMoneyPlantSaga";
import CryptoPayment from "./payments/cryptoPaymentSaga";
import StripePayment from "./payments/stripePaymentSaga";

import MonumpayDeposit from "./monumpay/monumpaySaga";
import MonumpayWithdrawalRequest from "./monumpay/monumpayWithdrawalRequestSaga";
import MonumpayWithdrawal from "./monumpay/monumpayWithdrawalSaga";
import BankWireTransfer from "./dashboard/bankWireTransferSaga";

import NGeniusDeposit from "./ngenius/ngeniusDepositSaga";

import EmailWithdraw from "./dashboard/emailWithdrawSaga";
import GetWhitelabel from "./whitelabel/getWhitelabelSaga"
import GetDashBoardData from "./dashboard/getDashboardDataSaga";
import GetTransactions from "./dashboard/getTransactionSaga";
import CreateLiveAccount from "./dashboard/createLiveAccountSaga"
import GetPartnerAccount from "./dashboard/getPartnerAccountSaga"
import MT5DEPOSIWIDTHDRAW from "./mt5/mt5DepositWidthSaga"
import GetUserActivity from "./dashboard/getActivitiesSaga"
import SendProfileData from "./dashboard/sendProfileDataSaga"
import SupportTicket from "./supportTicketSaga"
import  TradeOrderSaga  from "./dashboard/tradeOrderSaga"
import CorporateSignup from "./corporateSignup/corporateSignupSaga";

export default function* rootSaga() {
  yield all([
    Signup(),
    Login(),
    Logout(),
    CompleteKYC(),
    KYCAuth(),
    GetBalance(),
    GetUserData(),
    DepositMoneyPlant(),
    VerifyEmail(),
    CryptoPayment(),
    AddNewAddress(),
    GetAddressCard(),
    MonumpayDeposit(),
    MonumpayWithdrawalRequest(),
    MonumpayWithdrawal(),
    BankWireTransfer(),
    NGeniusDeposit(),
    EmailWithdraw(),
    GetWhitelabel(),
    GetDashBoardData(),
    GetTransactions(),
    CreateLiveAccount(),
    GetPartnerAccount(),
    MT5DEPOSIWIDTHDRAW(),
    GetUserActivity(),
    SendProfileData(),
    SupportTicket(),
    TradeOrderSaga(),
    StripePayment(),
    CorporateSignup(),
  ]);
}